import { createContext } from 'react';
import type { SharedValue } from 'react-native-reanimated';

type HomeScrollContextType = {
  headerVisible: SharedValue<number>; // 1 = visible, 0 = hidden
  scrollY: SharedValue<number>;
  onScrollY: (scrollY: number) => void;
  /** 활성 탭을 최상단으로 스크롤. 등록된 탭이 없으면 noop. */
  scrollToTop: () => void;
  /** 활성 탭에서 scrollToTop 함수를 등록/해제. 비활성화 시 null 전달. */
  registerScrollToTop: (fn: (() => void) | null) => void;
};

export const HomeScrollContext = createContext<HomeScrollContextType | null>(
  null,
);